module.exports = __webpack_public_path__ + "img/91763.940881e5.svg";